import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import configureAxios from "./api/axios.interceptor";
import Buefy from 'buefy';


Vue.config.productionTip = false;

configureAxios();

Vue.use(VueAxios, axios)
Vue.use(Buefy);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


